import { render, staticRenderFns } from "./mobile_menu.vue?vue&type=template&id=9ed23656&"
import script from "./mobile_menu.vue?vue&type=script&lang=js&"
export * from "./mobile_menu.vue?vue&type=script&lang=js&"
import style0 from "./mobile_menu.vue?vue&type=style&index=0&id=9ed23656&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports